module.exports = __webpack_public_path__ + "static/media/more.b6fa83fb.svg";